import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=5f13815a&scoped=true&"
import script from "./DealList.vue?vue&type=script&lang=ts&"
export * from "./DealList.vue?vue&type=script&lang=ts&"
import style0 from "./DealList.vue?vue&type=style&index=0&id=5f13815a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13815a",
  null
  
)

export default component.exports